import React, { createContext, useContext, useState, useEffect } from 'react';

const GuestContext = createContext();

export const useGuestContext = () => {
  const context = useContext(GuestContext);
  if (!context) {
    throw new Error('useGuestContext must be used within a GuestProvider');
  }
  return context;
};

export const GuestProvider = ({ children }) => {
  // Default guest data
  const getDefaultGuests = () => {
    return {
      rooms: 1,
      adults: 2,
      children: 1,
      pets: 1
    };
  };

  // Initialize from localStorage or use defaults
  const initializeGuests = () => {
    try {
      const stored = localStorage.getItem('globalSelectedGuests');
      if (stored) {
        const parsed = JSON.parse(stored);
        // Validate the stored data
        if (parsed.rooms >= 1 && parsed.adults >= 1 && parsed.children >= 0 && parsed.pets >= 0) {
          return parsed;
        }
      }
    } catch (error) {
      console.warn('Failed to load guests from localStorage:', error);
    }
    return getDefaultGuests();
  };

  const [guestData, setGuestData] = useState(initializeGuests);

  // Save to localStorage whenever guest data changes
  useEffect(() => {
    try {
      localStorage.setItem('globalSelectedGuests', JSON.stringify(guestData));
    } catch (error) {
      console.warn('Failed to save guests to localStorage:', error);
    }
  }, [guestData]);

  const updateGuests = (guests) => {
    setGuestData(prev => ({
      ...prev,
      ...guests
    }));
  };

  const formatGuestString = () => {
    const { rooms, adults, children, pets } = guestData;
    return {
      roomText: `${rooms} Room${rooms > 1 ? 's' : ''}`,
      guestText: `${adults} Adult${adults > 1 ? 's' : ''} ${children} Child${children !== 1 ? 'ren' : ''} ${pets} Pet${pets > 1 ? 's' : ''}`,
      fullString: `${rooms} Room${rooms > 1 ? 's' : ''} ${adults} Adult${adults > 1 ? 's' : ''} ${children} Child${children !== 1 ? 'ren' : ''} ${pets} Pet${pets > 1 ? 's' : ''}`
    };
  };

  const value = {
    guestData,
    updateGuests,
    formatGuestString,
    getDefaultGuests
  };

  return (
    <GuestContext.Provider value={value}>
      {children}
    </GuestContext.Provider>
  );
};





